export default "__VITE_ASSET__YvU0dylW__"